import { Button, Form, Input, message } from "antd";
import { Auth } from "aws-amplify";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import "./login.css";
interface LoginFormProps {
  onBackToLogin: (value: React.SetStateAction<boolean>) => void;
}

type FieldTypeEmail = {
  userName?: string;
};

type FieldTypeCode = {
  code?: string;
  newPassword?: string;
};

type FormState = "email" | "code";

export function PasswordRestForm({ onBackToLogin }: LoginFormProps) {
  const [formState, setFormState] = useState<FormState>("email");
  const [userName, setUserName] = useState<string>("");

  return (
    <>
      {formState === "email" ? (
        <EnterEmailForm
          setUserName={setUserName}
          setFormState={setFormState}
          onBackToLogin={onBackToLogin}
        />
      ) : (
        <EnterCodeForm
          userName={userName}
          setFormState={setFormState}
          onBackToLogin={onBackToLogin}
        />
      )}
    </>
  );
}

interface EnterEmailFormProps {
  setUserName: React.Dispatch<React.SetStateAction<string>>;
  setFormState: React.Dispatch<React.SetStateAction<FormState>>;
  onBackToLogin: (value: React.SetStateAction<boolean>) => void;
}

const EnterEmailForm = ({
  setUserName,
  setFormState,
  onBackToLogin,
}: EnterEmailFormProps) => {
  const { t } = useTranslation();

  const sendResetCode = async (userName: string) => {
    setUserName(userName);
    try {
      await Auth.forgotPassword(userName);
      setFormState("code");
    } catch (err: any) {
      message.error(err.message || t("password-rest:reset-password-error"));
    }
  };

  return (
    <Form
      name="basic"
      labelCol={{ span: 24 }}
      wrapperCol={{ span: 24 }}
      className="reset-form-container"
      initialValues={{ remember: true }}
      onFinish={(values) => sendResetCode(values.userName)}
      autoComplete="off"
      requiredMark={false}
    >
      <h1 style={{ color: "white", margin: "40px 0 40px 0" }}>
        {t("password-reset:title")}
      </h1>
      <Form.Item<FieldTypeEmail>
        label={
          <span className="form-label">
            {t("password-reset:enter-your-email-address")}
          </span>
        }
        name="userName"
        style={{ color: "white" }}
        rules={[{ required: true, message: t("login:email-validation-error") }]}
      >
        <Input style={{ fontSize: "16px", height: "40px" }} />
      </Form.Item>

      <Form.Item label={null}>
        <Button
          type="primary"
          htmlType="submit"
          style={{
            display: "flex",
            justifyContent: "center",
            width: "100%",
            marginTop: "15px",
            height: "40px",
          }}
        >
          <span style={{ color: "white", fontSize: "16px" }}>
            {t("password-reset:button-send-code")}
          </span>
        </Button>
      </Form.Item>
      <Form.Item>
        <span
          style={{ color: "white", cursor: "pointer" }}
          onClick={() => onBackToLogin(false)}
        >
          <i>{t("password-reset:back-to-login")}</i>
        </span>
      </Form.Item>
    </Form>
  );
};

interface EnterCodeFormProps {
  userName: string;
  setFormState: React.Dispatch<React.SetStateAction<FormState>>;
  onBackToLogin: (value: React.SetStateAction<boolean>) => void;
}

const EnterCodeForm = ({ userName, onBackToLogin }: EnterCodeFormProps) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();

  const submitNewPassword = async (
    userName: string,
    code: string,
    newPassword: string
  ) => {
    try {
      await Auth.forgotPasswordSubmit(userName, code, newPassword);
      message.success(t("password-reset:reset-password-success"));
      form.resetFields();
    } catch (error: any) {
      message.error(error.message || t("password-reset:rest-password-error"));
    }
  };

  return (
    <Form
      form={form}
      name="basic"
      labelCol={{ span: 24 }}
      wrapperCol={{ span: 24 }}
      className="reset-form-container"
      initialValues={{ remember: true }}
      onFinish={(values) =>
        submitNewPassword(userName, values.code, values.newPassword)
      }
      autoComplete="off"
      requiredMark={false}
    >
      <h1 style={{ color: "white", margin: "40px 0 40px 0" }}>
        {t("password-reset:title")}
      </h1>
      <Form.Item<FieldTypeCode>
        label={
          <span className="form-label">
            {t("password-reset:verification-code")}
          </span>
        }
        name="code"
        style={{ color: "white" }}
        rules={[{ required: true, message: t("password-reset:code-validation-error") }]}
      >
        <Input style={{ fontSize: "16px", height: "40px" }} />
      </Form.Item>

      <Form.Item<FieldTypeCode>
        label={
          <span className="form-label">
            {" "}
            {t("password-reset:new-password")}
          </span>
        }
        name="newPassword"
        style={{ color: "white" }}
        rules={[
          { required: true, message: t("login:password-validation-error") },
        ]}
      >
        <Input.Password style={{ fontSize: "16px", height: "40px" }} />
      </Form.Item>

      <Form.Item label={null}>
        <Button
          type="primary"
          htmlType="submit"
          style={{
            display: "flex",
            justifyContent: "center",
            width: "100%",
            marginTop: "15px",
            height: "40px",
          }}
        >
          <span style={{ color: "white", fontSize: "16px" }}>
            {t("password-reset:submit")}
          </span>
        </Button>
      </Form.Item>
      <Form.Item>
        <span
          style={{ color: "white", cursor: "pointer" }}
          onClick={() => onBackToLogin(false)}
        >
          <i> {t("password-reset:back-to-login")}</i>
        </span>
      </Form.Item>
    </Form>
  );
};
